import { render, staticRenderFns } from "./mySecond.vue?vue&type=template&id=4725dc9b&scoped=true"
import script from "./mySecond.vue?vue&type=script&lang=js"
export * from "./mySecond.vue?vue&type=script&lang=js"
import style0 from "./mySecond.vue?vue&type=style&index=0&id=4725dc9b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4725dc9b",
  null
  
)

export default component.exports